/*
   公共接口请求地址
*/
export default {
  /** oss上传 */
  OSS_UPLOAD_API: '/maindata/dict/ossUpload',
  /** 获取字典值 */
  DIC_CREDIT_API: '/maindata/dictData/listDataDictByDataType',
  /** 获取合作伙伴列表 */
  PARTNER_LIST_API: '/maindata/partners/listPartner',
  /** 获取人员列表 */
  PERSON_LIST_API: '/maindata/person/listPersonByPage',
  /**获取人员相关信息*/
  GET_PERSON_API: '/maindata/person/listPerson',
  /** 仓库列表 */
  STORAGE_LIST_API: '/maindata/storage/listStorageByPage',
  /** 商品列表-大类 */
  GOODS_LIST_API: '/maindata/product/listProduct',
  // 商品明细列表查询
  LIST_DETAIL_PRODUCT: '/maindata/productDetail/listProductDetail',
  // 查询公司
  LISTDATA_SERECHCOMPANY: '/maindata/company/listCompanyByTenantCode',
  // 查询多式联运项目-联动单位
  LISTDATA_DSLYSERECHCOMPANY: '/maindata/company/listCompanyInMto',
  // 查询公司树
  LISTDATA_SERECHCOMPANYTREE: '/maindata/company/listCompanyOneDepartmentTree',
  /**查询公司-部门树 */
  LIST_COMPANY_DEPT_TREE: '/maindata/company/listCompanyDepartmentTree',
  /**查询控制范围-部门树 */
  LIST_CONTROL_AREA_DEPARTMENT_API: '/maindata/controlArea/listControlAreaDepartmentTree',
  //根据公司编码查询部门
  LIST_DEPARTMENT_API: '/maindata/department/listDepartmentByCompanyCode',
  // 币种查询
  LIST_CURRENCY: '/maindata/currency/listCurrency',
  //获取当前账号的列
  GET_COLUMNS_LIST_API: '/maindata/tableInfo/listTableInfos',
  //新增当账号动态列
  ADD_COLUMNS_API: '/maindata/tableInfo/addTableInfos',
  // 获取用户角色
  GET_ROLE: '/maindata/role/listRoleByUserId',
  // 修改密码api
  UPDATE_PASSWORD: '/maindata/userAccount/updateUserPassword',
  //信用额度-事业部门树 交易量
  LIST_TREE: '/maindata/controlArea/listControlAreaDepartmentTree',
  // 银行列表
  GET_LIST_BANK: '/maindata/sysBank/queryListByParam',
  // 分行列表
  GET_LIST_BANKBRANCH: '/maindata/sysBankBranch/listSysBankByPage',
  // 银行账户
  GET_LIST_BANKACCOUNT: '/maindata/sysBankAccount/queryList',
  //获取商品分类树 集团商品类别（原来字典表：group_category）
  GET_PRODUCT_CAT_TREE: '/maindata/sysProductCategory/treeSelect',
  //获取所有商品单位（原来字典表basic_unit)
  GET_PRODUCT_UNIT_LIST: '/maindata/sysProductUnit/queryList',
  //获取国家（原来字典表：person_national）
  QUERY_COUNTRY: '/maindata/sysArea/queryCounty',
  //获取省（原来字典表province）
  QUERY_PROVICE: '/maindata/sysArea/queryProvince',
  //获取市（原来字典表city）
  QUERY_CITY: '/maindata/sysArea/queryCity',
  //获取地区
  QUERY_AERA: '/maindata/sysArea/queryRegion',
  // 汇率查询
  GET_CURRENCY_EXCHANGE: '/maindata/currencyExchange/getCurrencyExchange',
  // 获取会计科目表
  QUERY_SYSACCOUNTLIST: '/maindata/sysAccount/queryList',
  //获取账套信息 通过公司代码
  GET_LEDGER: '/maindata/ledger/getLedger',
  // 公司部门分页查询
  QUERY_DEPT_BYPAGE: 'maindata/department/queryDepartmentsByPage',
  // 税率
  QUERY_TAX_RATE: '/maindata/sysTaxRate/queryList',
  // 获取模块
  QUERY_TAE_APPLICATION: '/financial/tAeApplication/queryList',
  // 获取凭证类型
  QUERY_SAP_VOUCHER_TYPE: '/financial/sapVoucherType/queryList',
  /**查询公司-部门树 */
  LIST_COMPANY_API: '/maindata/company/listCompanyDepartmentTree',
  //打印查询
  GET_FILE: '/maindata/dict/getFileTemplate',
  // 生成凭证
  GENARATE_VOUCHER: '/genarateVoucher',
  // 单据查询凭证
  QUERY_VOUCHER: '/financial/voucherHeader/queryVoucherByEntityData',
  // 销售提单和销售退货只做个查询凭证的功能  ladingNo=#提单号或者退货号#,isTh=#0，提单；1退货#
  QUERY_LADING_VOUCHERS: '/financial/financeSalesInvoice/queryLadingVouchers',
  //获取科目 通过账套代码,或公司代码
  GET_ACCOUNTDETAIL: '/maindata/sysAccountDetail/queryList',
  GET_ACCOUNTDETAIL_PAGE: '/maindata/sysAccountDetail/queryPage',
  //sap公司代码查询list
  LIST_SAP_COMPANY_CODE: '/financial/sapCompanyCode/queryList',
  //凭证模块查询list
  LIST_AE_APPLICATION: '/financial/tAeApplication/queryList',
  //会计期间list
  LIST_FINANCE_LEDGER_PERIOD: '/financial/financeLedgerPeriod/queryListForVoucher',
  // 判断期间
  CHECK_ISOPENPERIOD: '/financial/financeLedgerPeriod/isOpenPeriod',
  // 现金流量代码
  GET_SAPCASHFLOW_PAGE: '/financial/sapCashflow/queryPage',
  // sap供应商/客户
  GET_SPAPARTNER: '/maindata/partners/listSapPartner',
  // 获取成本中心
  GET_SAPCOSTCENTER: '/financial/sapCostCenter/queryPage',
  // 获取利润中心
  GET_SAPPROFITCENTER: '/financial/sapProfitCenter/queryPage',
  // 费用类型 大类："leafFlag":"N"，小类："leafFlag":"Y"
  GET_EXPENSETYPE: '/maindata/sysExpenseType/queryForSelect',
  // 费用小类格式下拉服务 大类："leafFlag":"N"，小类："leafFlag":"Y"
  GET_EXPENSETYPE_FORMAT: '/maindata/sysExpenseType/queryForSelectFormat',
  // 银行账户弹出table
  QUERY_BANKACCOUNT_PAGE: '/maindata/sysBankAccount/queryPageForSelect',
  // 各模块判断是否已关联结算批次
  CHK_ORDERSETTLE: '/sales/orderSettle/checkIsAssociationWithOrderSettle',
  // 统一下载
  DOWNLOAD_FILE: '/component/attachment/downloadAttachment',
  // 传真历史
  FAXLIST: '/component/aofaxSendTask/queryPage',
  // 合作伙伴详情
  GET_PARTNER: '/maindata/partners/getPartner',

  //查询合作伙伴类型
  GET_PARTNER_TYPE: '/financial/fundCollectionOrder/getPartnerType',
  // 合作伙伴根据编码查询
  LIST_GETPARTNERADDRESSINFO: '/maindata/partners/getPartnerAddressInfo',
  // 获取oa的token
  GET_OA_TOKEN: '/maindata/sso/getToken',
};
